"use client";
import { Drawer, DrawerContent } from "@components/ui/drawer";
import { useMediaQuery } from "@lib/utils/hooks/useMediaQuery";
import { PathResponse } from "@repo/shared-types";

import { PathPopupContent } from "./pathPopupContent/PathPopupContent";

function PathPopup({
  selectedPath,
  clear,
}: {
  selectedPath?: PathResponse;
  clear?: () => void;
}) {
  const isDesktop = useMediaQuery("(min-width: 768px)");
  if (!selectedPath) return null;
  if (isDesktop) {
    return (
      <div className="max-w-unset absolute right-[100px] top-1/2 w-[300px] -translate-y-1/2  transform rounded-xl bg-primary-foreground p-4 shadow-lg ">
        <PathPopupContent
          id={selectedPath.id}
          name={selectedPath.name}
          region={selectedPath.region.name}
          clear={clear}
        />
      </div>
    );
  }

  return (
    <Drawer open={!!selectedPath} onClose={clear}>
      <DrawerContent className="rounded-t-2xl">
        <PathPopupContent
          name={selectedPath.name}
          region={selectedPath.region.name}
          id={selectedPath.id}
        />
      </DrawerContent>
    </Drawer>
  );
}

export default PathPopup;
